import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpSingleArticle',
  props: {
    article: null
  },
  setup(__props: any) {

const props = __props as {
  article: {
    title: {
      head: string;
      description: string;
      image: string;
    };
    author: {
      name: string;
      update: string;
      image: string;
    };
    content: string;
  };
};



return { __sfc: true,props }
}

})